import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import medicionesStyles from './medicionesStyles';

/** Bloque informativo y estático de rangos sugeridos: no recibe estado del panel. */
const RangosSugeridos = ({ id, rangos, nota }) => {
	const classes = medicionesStyles();
	return (
		<section id={`${id}-rangos-sugeridos`} aria-labelledby={`${id}-rangos-titulo`} className={classes.rangosSugeridos}>
			<Typography id={`${id}-rangos-titulo`} variant="subtitle2" component="h4">
				Rangos sugeridos
			</Typography>
			<ul>
				{rangos.map((r) => (
					<li key={r.categoria}>
						<strong>{r.categoria}</strong>{`: ${r.rango}`}
					</li>
				))}
			</ul>
			<Typography id={`${id}-rangos-nota`} variant="body2" component="p">
				{nota}
			</Typography>
		</section>
	);
};

RangosSugeridos.propTypes = {
	id: PropTypes.string.isRequired,
	rangos: PropTypes.arrayOf(PropTypes.shape({
		categoria: PropTypes.string.isRequired,
		rango: PropTypes.string.isRequired,
	})).isRequired,
	nota: PropTypes.string.isRequired,
};

export default RangosSugeridos;
